export default __webpack_public_path__ + "static/media/Selenium-testng-java.fbf7bff4.png";